import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=6be25550&"
import script from "./MessageDetail.vue?vue&type=script&lang=js&"
export * from "./MessageDetail.vue?vue&type=script&lang=js&"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=6be25550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports